/* src/app/main/matching/wizard/steps/auto-match/matching-auto-match.component.scss */
table {
  font-size: small;
  justify-content: left;
  width: 50%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
thead {
  background-color: #1b638b;
  font-weight: 300;
  font-size: 11pt;
  height: 40px;
  color: #fff;
}
tbody tr:nth-child(even) {
  background-color: #f8f8f8;
}
tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
th,
td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  text-align: left;
  border-bottom: 1px solid #ebebeb;
}
th:first-child,
td:first-child {
  border-left: none;
}
th:last-child,
td:last-child {
  border-right: none;
}
tr {
  border: 1px solid #ebebeb;
  overflow: hidden;
}
tbody tr:last-child td {
  border-bottom: none;
}
tfoot {
  width: 100%;
  background-color: #e0e0e0;
  font-weight: bold;
  font-size: 11pt;
  color: #444444;
}
.status {
  font-weight: bold;
  font-style: italic;
  color: #e69e69;
}
.status.done {
  font-style: normal;
  color: #0baa0b;
}
/*# sourceMappingURL=matching-auto-match.component-GLOWQYHN.css.map */
